import { Component, EventEmitter, Input, Output } from '@angular/core';
import { ButtonModule } from 'primeng/button';
import { SidebarModule } from 'primeng/sidebar';

@Component({
  selector: 'oms-simple-sidebar',
  standalone: true,
  imports: [SidebarModule, ButtonModule],
  templateUrl: './simple-sidebar.component.html',
  styleUrl: './simple-sidebar.component.scss',
})
export class SimpleSidebarComponent {
  @Input() title!: string;
  @Input() sidebarVisible: boolean = false;
  @Input() showFocus: boolean = true;
  @Output() sidebarClosed: EventEmitter<void> = new EventEmitter<void>();

  closeSidebar() {
    this.sidebarClosed.emit();
    this.sidebarVisible = false; // Sets the sidebar visibility to false
  }
}
